"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DispatchListShowSet = DispatchListShowSet;
exports.add = add;
exports.custShowSet = custShowSet;
exports.default = void 0;
exports.del = del;
exports.deptUser = deptUser;
exports.edit = edit;
exports.editCustShow = editCustShow;
exports.editExportShow = editExportShow;
exports.editUser = editUser;
exports.exportShowSet = exportShowSet;
exports.getOrderRecordListShow = getOrderRecordListShow;
exports.getSpecialApplyListShow = getSpecialApplyListShow;
exports.getWorkListShowSet = getWorkListShowSet;
exports.resetPass = resetPass;
exports.syncUserAppuid = syncUserAppuid;
exports.updateDispatchListShow = updateDispatchListShow;
exports.updateEmail = updateEmail;
exports.updateOrderRecordListShow = updateOrderRecordListShow;
exports.updatePass = updatePass;
exports.updateSpecialApplyListShow = updateSpecialApplyListShow;
exports.updateWorkListShow = updateWorkListShow;

var _request = _interopRequireDefault(require("@/utils/request"));

var _rsaEncrypt = require("@/utils/rsaEncrypt");

function add(data) {
  return (0, _request.default)({
    url: 'api/users',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/users',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/users',
    method: 'put',
    data: data
  });
}

function editUser(data) {
  return (0, _request.default)({
    url: 'api/users/center',
    method: 'put',
    data: data
  });
}

function editCustShow(data) {
  return (0, _request.default)({
    url: 'api/users/updateCustShow',
    method: 'put',
    data: data
  });
}

function editExportShow(data) {
  return (0, _request.default)({
    url: 'api/users/updateExportShow',
    method: 'put',
    data: data
  });
}

function updateDispatchListShow(data) {
  return (0, _request.default)({
    url: 'api/users/updateDispatchListShow',
    method: 'put',
    data: data
  });
}

function DispatchListShowSet(data) {
  return (0, _request.default)({
    url: 'api/users/getDispatchListShow',
    method: 'get',
    data: data
  });
}

function updateWorkListShow(data) {
  return (0, _request.default)({
    url: 'api/users/updateWorkListShow',
    method: 'put',
    data: data
  });
}

function updateSpecialApplyListShow(data) {
  return (0, _request.default)({
    url: 'api/users/updateSpecialApplyListShow',
    method: 'put',
    data: data
  });
}

function getWorkListShowSet(data) {
  return (0, _request.default)({
    url: 'api/users/getWorkListShow',
    method: 'get',
    data: data
  });
}

function updateOrderRecordListShow(data) {
  return (0, _request.default)({
    url: 'api/users/updateOrderRecordListShow',
    method: 'put',
    data: data
  });
}

function getOrderRecordListShow(data) {
  return (0, _request.default)({
    url: 'api/users/getOrderRecordListShow',
    method: 'get',
    data: data
  });
}

function getSpecialApplyListShow(data) {
  return (0, _request.default)({
    url: 'api/users/getSpecialApplyListShow',
    method: 'get',
    data: data
  });
}

function updatePass(user) {
  var data = {
    oldPass: (0, _rsaEncrypt.encrypt)(user.oldPass),
    newPass: (0, _rsaEncrypt.encrypt)(user.newPass)
  };
  return (0, _request.default)({
    url: 'api/users/updatePass/',
    method: 'post',
    data: data
  });
}

function resetPass(userId) {
  var data = {
    userId: userId,
    newPass: (0, _rsaEncrypt.encrypt)("123456")
  };
  return (0, _request.default)({
    url: 'api/users/resetPass',
    method: 'post',
    data: data
  });
}

function custShowSet(data) {
  return (0, _request.default)({
    url: 'api/users/custShowSet',
    method: 'get',
    data: data
  });
}

function exportShowSet(data) {
  return (0, _request.default)({
    url: 'api/users/exportShowSet',
    method: 'get',
    data: data
  });
}

function updateEmail(form) {
  var data = {
    password: (0, _rsaEncrypt.encrypt)(form.pass),
    email: form.email
  };
  return (0, _request.default)({
    url: 'api/users/updateEmail/' + form.code,
    method: 'post',
    data: data
  });
}

function deptUser(deptId, page) {
  var data = {};
  return (0, _request.default)({
    url: 'api/users/deptUsesr?enabled=true&size=1000&deptId=' + deptId + '&page=' + page,
    method: 'get',
    data: data
  });
}

function syncUserAppuid(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/syncUserAppuid',
    method: 'post',
    data: data
  });
}

var _default = {
  getSpecialApplyListShow: getSpecialApplyListShow,
  updateSpecialApplyListShow: updateSpecialApplyListShow,
  getOrderRecordListShow: getOrderRecordListShow,
  updateOrderRecordListShow: updateOrderRecordListShow,
  getWorkListShowSet: getWorkListShowSet,
  updateWorkListShow: updateWorkListShow,
  add: add,
  edit: edit,
  del: del,
  editCustShow: editCustShow,
  editExportShow: editExportShow,
  updateDispatchListShow: updateDispatchListShow,
  DispatchListShowSet: DispatchListShowSet,
  custShowSet: custShowSet,
  deptUser: deptUser,
  resetPass: resetPass,
  exportShowSet: exportShowSet,
  syncUserAppuid: syncUserAppuid
};
exports.default = _default;